// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createActionsHook, createStateHook } from '@atlassian/react-sweet-state';
import type { LayoutState } from '../../../../common/types.tsx';
import type { LayoutActions } from '../../actions/index.tsx';
import { layoutStore } from '../../store/index.tsx';

export const useBottomRightCornerContainer = createStateHook<
	LayoutState,
	LayoutActions,
	HTMLElement | undefined,
	undefined
>(layoutStore, {
	selector: (state) => state.bottomRightCorner.container,
});

export const useBottomRightCornerActions = createActionsHook<LayoutState, LayoutActions>(
	layoutStore,
);
